export const PUB_CONTENT = {
  hero: {
    kicker: 'Para quem quer vender online sem virar refém de marketplace',
    title: 'Sua vitrine online, com a sua cara, sem comissão de marketplace.',
    subtitle:
      'Catálogo público com link próprio, produtos e preços sempre sincronizados com o seu estoque real. O cliente monta o carrinho e finaliza pelo WhatsApp ou por uma proposta comercial — sem taxa de gateway obrigatória.',
    cta: 'Quero meu catálogo online',
    ctaMessage: 'Quero conhecer o catálogo de produtos online do 77Gestão',
    urgency: 'Enquanto seu catálogo é uma foto no WhatsApp, o concorrente já manda um link profissional para o cliente.',
  },

  statsStrip: [
    { number: '1 link', label: 'com a cara da sua empresa', icon: 'fa-solid fa-link' },
    { number: 'Tempo real', label: 'sincronizado com o estoque', icon: 'fa-solid fa-arrows-rotate' },
    { number: '0', label: 'comissão de marketplace', icon: 'fa-solid fa-hand-holding-dollar' },
  ],

  pain: {
    title: 'Reconhece alguma dessas situações? Então você sabe que algo precisa mudar.',
    intro:
      'Empresas que vendem por catálogo perdem venda e credibilidade todos os dias por causa de tabela desatualizada e atendimento manual. Não é falta de esforço — é falta da ferramenta certa.',
    items: [
      { icon: 'fa-solid fa-file-pdf', text: 'Tabela de produto enviada em PDF ou foto no WhatsApp, atualizada na mão de vez em quando.' },
      { icon: 'fa-solid fa-triangle-exclamation', text: 'Cliente pergunta "isso ainda tem?" e ninguém tem certeza porque o catálogo não bate com o estoque.' },
      { icon: 'fa-solid fa-percent', text: 'Marketplace cobrando comissão alta em cima de cada venda que você poderia ter feito direto.' },
      { icon: 'fa-solid fa-code', text: 'Montar um e-commerce completo parece caro e complicado demais para o tamanho do seu negócio.' },
      { icon: 'fa-regular fa-clock', text: 'Tempo perdido respondendo preço e disponibilidade um por um, produto por produto.' },
    ],
  },

  midCta: {
    text: 'E se você tivesse um link só seu, com produtos sempre atualizados, para mandar para qualquer cliente agora?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do catálogo de produtos online do 77Gestão',
  },

  solution: {
    title: 'Uma vitrine online própria, sem depender de marketplace.',
    intro:
      'O catálogo público do 77Gestão foi pensado para quem quer vender online sem montar um e-commerce completo e sem pagar comissão para vender o que é seu.',
    cards: [
      {
        icon: 'fa-solid fa-store',
        title: 'Catálogo com a cara da sua empresa',
        text: 'Link próprio, com seu logo e suas cores, pronto para compartilhar nas redes sociais, no WhatsApp ou no Google.',
      },
      {
        icon: 'fa-solid fa-arrows-rotate',
        title: 'Sincronizado com o estoque real',
        text: 'Produtos, preços e disponibilidade puxados direto do estoque do ERP. Sem catálogo desatualizado nem venda de produto que já acabou.',
      },
      {
        icon: 'fa-solid fa-cart-shopping',
        title: 'Carrinho que finaliza pelo WhatsApp',
        text: 'O cliente monta o pedido no catálogo e finaliza direto pelo WhatsApp, sem sair da conversa que ele já conhece.',
      },
      {
        icon: 'fa-solid fa-file-invoice',
        title: 'Ou vira uma proposta comercial',
        text: 'Para pedidos maiores, o carrinho pode virar uma proposta formal dentro do sistema, pronta para aprovação.',
      },
      {
        icon: 'fa-solid fa-hand-holding-dollar',
        title: 'Sem comissão nem taxa obrigatória',
        text: 'Diferente de marketplace, você não paga comissão por venda. E diferente de checkout tradicional, não há taxa de gateway obrigatória.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando o catálogo para de ser uma foto no WhatsApp',
    intro:
      'Uma loja com venda mista de produtos mandava tabela de preço em PDF, atualizada de vez em quando. Cliente novo sempre perguntava se o preço ainda era aquele mesmo.',
    stats: [
      { number: '1 link', label: 'único para compartilhar em qualquer canal' },
      { number: '0', label: 'catálogo desatualizado depois do sistema' },
      { number: '0', label: 'comissão paga a marketplace' },
    ],
    paragraphs: [
      'Depois da implantação, o catálogo público passou a refletir o estoque real do ERP automaticamente — sem ninguém precisar atualizar tabela nenhuma.',
      'Os clientes passaram a montar o próprio pedido pelo link e finalizar direto pelo WhatsApp, reduzindo o tempo que a equipe gastava respondendo preço e disponibilidade um por um.',
    ],
    highlight: 'Resultado: catálogo sempre certo, menos tempo de atendimento manual e zero comissão de marketplace.',
    cta: 'Quero esse nível de controle',
    ctaMessage: 'Vi o resultado e quero entender como ter meu catálogo online no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares que mudam a venda por catálogo',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Seu catálogo sempre atualizado, com preço e disponibilidade reais, visível para qualquer cliente a qualquer hora.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Você decide o que aparece no catálogo, os preços e a identidade visual — sem depender de regras de marketplace.',
      },
      {
        icon: 'fa-solid fa-binoculars',
        title: 'Previsibilidade',
        text: 'Pedidos organizados via WhatsApp ou proposta, sem confusão de mensagem perdida na conversa.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas escolhem o catálogo do 77Gestão',
    items: [
      { icon: 'fa-solid fa-link', text: 'Catálogo integrado ao estoque, vendas e propostas — um só sistema, sem retrabalho.' },
      { icon: 'fa-solid fa-hand-holding-dollar', text: 'Sem comissão de marketplace e sem taxa de gateway obrigatória no pedido.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: seu catálogo sai no ar já configurado com a cara da sua empresa.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e muito bem avaliado.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'O catálogo processa pagamento online no carrinho?',
        answer:
          'Não. O catálogo gera o pedido para você finalizar pelo WhatsApp ou como uma proposta comercial dentro do sistema — o pagamento é combinado diretamente com o cliente, sem taxa de gateway obrigatória nem comissão de marketplace no meio do caminho.',
      },
      {
        question: 'Preciso atualizar o catálogo manualmente?',
        answer:
          'Não. Produtos, preços e disponibilidade são sincronizados automaticamente com o estoque cadastrado no ERP.',
      },
      {
        question: 'Dá para personalizar com a cor e o logo da minha empresa?',
        answer:
          'Sim. O catálogo público é personalizável com a identidade visual da sua empresa, com link próprio para compartilhar.',
      },
      {
        question: 'Funciona só com poucos produtos ou preciso de um catálogo grande?',
        answer:
          'Funciona para qualquer tamanho de mix de produtos, desde um catálogo enxuto até centenas de itens organizados por categoria.',
      },
      {
        question: 'Isso substitui um e-commerce completo?',
        answer:
          'Não é um checkout de e-commerce tradicional — é uma vitrine online integrada ao seu estoque, pensada para quem quer vender sem a complexidade e o custo de montar uma loja virtual completa.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de mandar foto de tabela no WhatsApp. Tenha um catálogo online de verdade.',
    subtitle:
      'Agende uma demonstração e veja, na prática, como ter uma vitrine online própria, sincronizada com o estoque e sem comissão de marketplace.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do catálogo de produtos online do 77Gestão',
  },

  seo: {
    title: 'Catálogo de Produtos Online para WhatsApp | 77Gestão',
    description:
      'Catálogo digital sincronizado com o estoque, pedido via WhatsApp ou proposta comercial. Vitrine virtual sem comissão de marketplace. Agende uma demonstração.',
  },
};
